/* Reskin: desktop collection carousels — reliable side arrows.
   The theme renders .slider-buttons INSIDE the scrolling <ul>, so the arrows
   scroll away with the row. We relocate them to the (stable) slider-component
   and drive the scroll ourselves on arrow click. */
(function () {
  function sliders() {
    return document.querySelectorAll('.slider-component-desktop');
  }

  function updateArrows(sc) {
    var ul = sc.querySelector('.slider--desktop');
    var prev = sc.querySelector('.slider-button--prev');
    var next = sc.querySelector('.slider-button--next');
    if (!ul) return;
    if (prev) prev.toggleAttribute('disabled', ul.scrollLeft <= 1);
    if (next) next.toggleAttribute('disabled', ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 1);
  }

  function setup(sc) {
    var ul = sc.querySelector('.slider--desktop');
    if (!ul) return;
    // The theme reparents these INTO the scrolling <ul>; move them back out.
    var buttons = sc.querySelector('.slider-buttons');
    if (buttons && buttons.parentElement !== sc) sc.appendChild(buttons);
    // Move "View all" up into the heading row (top-right, across from the title).
    var viewAll = sc.querySelector('.collection__view-all');
    if (viewAll) {
      var title = sc.parentElement && sc.parentElement.querySelector('.collection__title');
      if (title) title.appendChild(viewAll);
      else if (sc.parentElement) sc.parentElement.insertBefore(viewAll, sc.nextSibling);
    }
    // Keep the arrows' disabled state in sync with scroll position.
    if (!ul._reskinScrollBound) {
      ul._reskinScrollBound = true;
      ul.addEventListener('scroll', function () { updateArrows(sc); }, { passive: true });
    }
    updateArrows(sc);
  }

  function init() {
    sliders().forEach(setup);
  }

  /* Arrow clicks (capture phase + stopImmediatePropagation so the theme's own
     handler doesn't also fire and double-scroll). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.slider-component-desktop .slider-button');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var sc = btn.closest('.slider-component-desktop');
    var ul = sc && sc.querySelector('.slider--desktop');
    if (!ul) return;
    var dir = btn.classList.contains('slider-button--prev') ? -1 : 1;
    // Scroll a visible "page" minus one product (keeps one card as context).
    var slides = ul.querySelectorAll('.slider__slide');
    var per = slides.length > 1
      ? (slides[1].offsetLeft - slides[0].offsetLeft)
      : (slides[0] ? slides[0].getBoundingClientRect().width : ul.clientWidth / 4);
    var amount = Math.max(per, ul.clientWidth - per);
    // Little "loading" fade while the row eases to the next page.
    ul.classList.add('is-paging');
    clearTimeout(ul._reskinPageTimer);
    ul._reskinPageTimer = setTimeout(function () { ul.classList.remove('is-paging'); }, 300);
    ul.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }, true);

  /* Run now + whenever lazy-loaded sections appear (debounced). */
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(init, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
